import React from "react";
import { cn } from "@/lib/utils";
import { DEADLINE_TONE_CLASS, type DeadlineStatus } from "@/lib/deadline-status";

/**
 * Ô 2 dòng chuẩn cho bảng danh sách (30/10/2026): dòng trên là thông tin chính, dòng dưới là thông tin quản lý
 * đi kèm (người liên hệ · SĐT, người phụ trách, tình trạng hạn…) — cùng cỡ chữ / màu ở mọi trang danh sách.
 */
export function StackedCell({
  primary,
  secondary,
  align = "left",
  primaryClassName,
  secondaryClassName,
  title,
  testId,
}: {
  primary: React.ReactNode;
  secondary?: React.ReactNode;
  align?: "left" | "right";
  primaryClassName?: string;
  secondaryClassName?: string;
  title?: string;
  testId?: string;
}) {
  return (
    <div className={cn("min-w-0 leading-tight", align === "right" && "text-right")} title={title} data-testid={testId}>
      <div className={cn("text-[12px] text-slate-900", primaryClassName)}>{primary}</div>
      {secondary != null && secondary !== false && secondary !== "" && (
        <div className={cn("mt-0.5 text-[11px] text-slate-500 truncate", secondaryClassName)}>{secondary}</div>
      )}
    </div>
  );
}

/** Dòng phụ "người liên hệ · SĐT" (bỏ phần trống) */
export function contactLine(person?: string | null, phone?: string | null): string {
  return [person?.trim(), phone?.trim()].filter(Boolean).join(" · ");
}

/** Chữ tình trạng hạn có màu theo mức độ (quá hạn đỏ, sắp hạn cam, đã xong xanh) */
export function DeadlineText({ status, testId }: { status: DeadlineStatus; testId?: string }) {
  return (
    <span className={cn("whitespace-nowrap", DEADLINE_TONE_CLASS[status.tone])} data-testid={testId} data-tone={status.tone}>
      {status.label}
    </span>
  );
}
